import http from '../mpm-config/http-common';
import * as Constants from '../mpm-config/Constants';

class DeclarationVenteService {
  async findAllPaginated(size = Constants.DEFAULT_TABLE_ROWS, page = 1, searchCriteria) {
    return http(window.keycloak.token)
      .post(`/declarationVente/listDV`, { size, page, ...searchCriteria })
      .then((res) => res.data);
  }

  async findById(id) {
    return http(window.keycloak.token)
      .get(`/declarationVente/${id}`)
      .then((res) => res.data);
  }
  async findForView(id) {
    return http(window.keycloak.token)
      .get(`/declarationVente/viewDV/${id}`)
      .then((res) => res.data);
  }
  async findForEdit(id) {
    return http(window.keycloak.token)
      .get(`/declarationVente/editDV/${id}`)
      .then((res) => res.data);
  }

  async findDC(numeroVisa) {
    return http(window.keycloak.token)
      .post(`/declarationVente/findDC`, { numeroVisa })
      .then((res) => res.data);
  }

  async create(data) {
    return http(window.keycloak.token)
      .post('/declarationVente/saveNew', data)
      .then((res) => res.data);
  }
  async validate(data) {
    return http(window.keycloak.token)
      .post('/declarationVente/validateNew', data)
      .then((res) => res.data);
  }

  async update(id, data) {
    return http(window.keycloak.token)
      .put(`/declarationVente/${id}`, data)
      .then((res) => res.data);
  }

  async delete(data) {
    return http(window.keycloak.token)
      .delete(`/declarationVente/remove`, { data })
      .then((res) => res.data);
  }
  async deleteSubElement(id) {
    return http(window.keycloak.token)
      .delete(`/declarationVente/removeChildFromList/${id}`, {})
      .then((res) => res.data);
  }
}

export default new DeclarationVenteService();
